import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  Home, 
  Calendar, 
  LayoutGrid, 
  Building, 
  Lightbulb, 
  Settings,
  ListTodo,
  Rocket
} from 'lucide-react';import { homeFor } from '../../lib/roles';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b7bb9a58-a668-4de2-aa2e-f5e39e6e614e/artifacts/buijzrp9_App%20Icon%20Yellow.png";

const getNavItems = (role) => {
  const items = [
    { icon: Home, label: 'Dashboard', path: '/dashboard', testId: 'nav-dashboard', roles: ['admin', 'restaurant'] },
    { icon: Calendar, label: 'Roadmap', path: '/roadmap', testId: 'nav-roadmap', roles: ['admin', 'partner'] },
    { icon: ListTodo, label: 'Tasks', path: '/tasks', testId: 'nav-tasks', roles: ['admin', 'developer'] },
    { icon: Rocket, label: 'Release Features', path: '/release-features', testId: 'nav-release-features', roles: ['admin', 'partner', 'developer'] },
    { icon: LayoutGrid, label: 'Modules', path: '/modules', testId: 'nav-modules', roles: ['admin', 'partner'] },
    { icon: Building, label: 'Restaurants', path: '/restaurants', testId: 'nav-restaurants', roles: ['admin', 'partner'] },
    { icon: Lightbulb, label: 'Ideas', path: '/ideas', testId: 'nav-ideas', roles: ['admin', 'partner', 'restaurant'] },
    { icon: Settings, label: 'Settings', path: '/settings', testId: 'nav-settings', roles: ['admin'] },
  ];
  
  return items.filter(item => item.roles.includes(role));
};

export function Sidebar({ isCollapsed, isMobileOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const navItems = getNavItems(user?.role || 'restaurant');
  const sidebarClasses = `mayo-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`;

  return (
    <aside className={sidebarClasses} data-testid="sidebar">
      <div className="mb-6">
        <img 
          src={LOGO_URL} 
          alt="Mayo" 
          className="h-10 w-10 rounded-lg cursor-pointer"
          onClick={() => navigate(homeFor(user?.role))}
          data-testid="sidebar-logo"
        />
      </div>

      <nav className="flex flex-col items-center flex-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={item.testId}
              className={`sidebar-icon ${isActive ? 'active' : ''}`}
              title={item.label}
              aria-label={item.label}
            >
              <Icon size={20} />
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
